'use client';

import { useEffect } from 'react';

export function ReactScanProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    console.log('ReactScanProvider mounted, NODE_ENV:', process.env.NODE_ENV);
    
    if (process.env.NODE_ENV === 'development') {
      console.log('🔍 Loading react-scan...');
      
      import('react-scan').then((ReactScan) => {
        console.log('✅ React-scan loaded successfully:', ReactScan);
        
        ReactScan.scan({
          enabled: true,
          log: true,
          // Make it more sensitive - highlight components that render even once
          showToolbar: true, // Shows a toolbar if available
        });
        
        console.log('🚀 React-scan started with enhanced config');
      }).catch((error) => {
        console.error('❌ Failed to load react-scan:', error);
      });
    }
  }, []);

  return <>{children}</>;
} 